import React from 'react'
import { Link } from 'react-router-dom'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { IconContext } from 'react-icons'
import { IoMdCopy } from 'react-icons/io'
import './style.scss'

export const ShippingBlock = ({ transaction: { address, state, transactionId } }) => (
    <div
        className={`supplierTransactionStep ${state === 'CONFIRMED' && 'supplierTransactionStep--dispatched'} ${
            state === 'CANCELLED' && 'supplierTransactionStep--cancelled'
        }`}
        data-step="2"
    >
        <h2>Shipping</h2>

        <table>
            <tbody>
                <tr>
                    <th>Name:</th>
                    <td>
                        <CopyToClipboard text={address?.name}>
                            <span className="copyToClipboard">
                                {address?.name}
                                <IconContext.Provider value={{ className: 'copyToClipboardIcon' }}>
                                    <IoMdCopy />
                                </IconContext.Provider>
                            </span>
                        </CopyToClipboard>
                    </td>
                </tr>
                <tr>
                    <th>First line:</th>
                    <td>
                        <CopyToClipboard text={address.firstLine}>
                            <span className="copyToClipboard">
                                {address.firstLine}
                                <IconContext.Provider value={{ className: 'copyToClipboardIcon' }}>
                                    <IoMdCopy />
                                </IconContext.Provider>
                            </span>
                        </CopyToClipboard>
                    </td>
                </tr>
                <tr>
                    <th>Second line:</th>
                    <td>
                        <CopyToClipboard text={address.secondLine}>
                            <span className="copyToClipboard">
                                {address.secondLine}
                                <IconContext.Provider value={{ className: 'copyToClipboardIcon' }}>
                                    <IoMdCopy />
                                </IconContext.Provider>
                            </span>
                        </CopyToClipboard>
                    </td>
                </tr>
                <tr>
                    <th>City:</th>
                    <td>
                        <CopyToClipboard text={address.city}>
                            <span className="copyToClipboard">
                                {address.city}
                                <IconContext.Provider value={{ className: 'copyToClipboardIcon' }}>
                                    <IoMdCopy />
                                </IconContext.Provider>
                            </span>
                        </CopyToClipboard>
                    </td>
                </tr>
                <tr>
                    <th>Postcode:</th>
                    <td>
                        <CopyToClipboard text={address.postcode}>
                            <span className="copyToClipboard">
                                {address.postcode}
                                <IconContext.Provider value={{ className: 'copyToClipboardIcon' }}>
                                    <IoMdCopy />
                                </IconContext.Provider>
                            </span>
                        </CopyToClipboard>
                    </td>
                </tr>
                <tr>
                    <th>Country:</th>
                    <td>
                        <CopyToClipboard text={address.country}>
                            <span className="copyToClipboard">
                                {address.country}
                                <IconContext.Provider value={{ className: 'copyToClipboardIcon' }}>
                                    <IoMdCopy />
                                </IconContext.Provider>
                            </span>
                        </CopyToClipboard>
                    </td>
                </tr>
                <tr>
                    <th>Email:</th>
                    <td>
                        <CopyToClipboard text={address?.email}>
                            <span className="copyToClipboard">
                                {address?.email}
                                <IconContext.Provider value={{ className: 'copyToClipboardIcon' }}>
                                    <IoMdCopy />
                                </IconContext.Provider>
                            </span>
                        </CopyToClipboard>
                    </td>
                </tr>
                <tr>
                    <th>Mobile:</th>
                    <td>
                        <CopyToClipboard text={address.mobile}>
                            <span className="copyToClipboard">
                                {address.mobile}
                                <IconContext.Provider value={{ className: 'copyToClipboardIcon' }}>
                                    <IoMdCopy />
                                </IconContext.Provider>
                            </span>
                        </CopyToClipboard>
                    </td>
                </tr>
                <tr>
                    <th colSpan="2">
                        Email & mobile are for shipping purposes only. If you need to contact the user, please{' '}
                        <Link to={`/tickets/${transactionId}`}>click here to go to the manage tickets page</Link> and then click the "Email user"
                        button.
                    </th>
                </tr>
            </tbody>
        </table>
    </div>
)
